module.exports = __webpack_public_path__ + "static/img/VERESE-CHOCOLATE-MAPLE.85cb5b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/VERESE-CHOCOLATE-MAPLE.png
// module id = p/kr
// module chunks = 0